import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { Spinner } from 'design-react-kit/dist/design-react-kit';
import cx from 'classnames';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { getCalendarDayResults } from 'design-comuni-plone-theme/actions';
import { ConditionalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

import { viewDate } from 'design-comuni-plone-theme/helpers';

const messages = defineMessages({
  scadenza_bando: {
    id: 'scadenza_bando',
    defaultMessage: 'Scadenza dei termini per partecipare al bando',
  },
  scadenza_domande_bando: {
    id: 'scadenza_domande_bando',
    defaultMessage: 'Termine per le richieste di chiarimenti',
  },
  chiusura_procedimento_bando: {
    id: 'chiusura_procedimento_bando',
    defaultMessage: 'Chiusura del procedimento',
  },
});

const Item = ({ day, path, query, inEditMode }) => {
  const intl = useIntl();

  const calendarDayResults = useSelector(
    (state) => state.calendarDaySearch.subrequests,
  );
  const dispatch = useDispatch();

  const _day = viewDate(intl.locale, day);
  const dayStart = _day.startOf('day').format('YYYY/MM/DD HH:mm');
  const dayEnd = _day.endOf('day').format('YYYY/MM/DD HH:mm');

  const dateObject = new Date(day.start);
  const optionsDay = { day: 'numeric' };
  const optionsMonth = { month: 'long' };
  const optionsWeekDay = { weekday: 'short' };
  let dayFormatted = dateObject.toLocaleDateString('it-IT', optionsDay);
  let monthFormatted = dateObject.toLocaleDateString('it-IT', optionsMonth);
  let weekdayFornatted = dateObject.toLocaleDateString('it-IT', optionsWeekDay);
  let url_image_preview = null;
  let image_preview = '';

  if (day.preview_image && day.preview_image.download) {
    url_image_preview = day.preview_image.download;
    image_preview = (
      <img
        src={url_image_preview}
        alt="preview_image"
        width={'200px'}
        className="pt-2"
      />
    );
  }

  useDeepCompareEffect(() => {
    dispatch(
      getCalendarDayResults(
        path,
        {
          ...query,
          query: [
            ...query.query,
            {
              i: 'start',
              o: 'plone.app.querystring.operation.date.between',
              v: [dayStart, dayEnd],
            },
          ],
        },
        day,
      ),
    );
  }, [dayStart, dayEnd, query, day, dispatch, path]);

  return (
    <div id="calendar-events-block">
      <div className="pl-3">
        <div className={cx('day', { 'mb-3': inEditMode })}>
          <h4 className="d-inline-block">{dayFormatted}</h4>
          &nbsp;
          <h6 className="d-inline-block">{monthFormatted}</h6>
          <span className={cx('month', { 'ml-1': inEditMode })}></span>
          {/* <p className="h6 day-week">{weekdayFornatted}</p> */}
        </div>
      </div>
      <div>
        <hr />
        {
          <div className="calendar-item">
            <div className="pl-3">
              <a href={day['@id']}>
                <b>{day.title}</b>
              </a>
              <hr />
              <div className="event-description">{day.description}</div>
              {image_preview}
            </div>
            <div></div>
          </div>
        }
      </div>
    </div>
  );
};

export default Item;
